<app-spinner *ngIf="isSpinner" [isSpinning]="isSpinner"></app-spinner>
<div class="dashboard-container" *ngIf="!isSpinner">
  <nz-card class="card-body">
    <div class="dashboard-wrapper">
      <span>{{'dashboard' |translate}}</span>
      <nz-table nzTemplateMode class="dashboard-table" [attr.lang]="currentLang" [nzTableLayout]="narrowLayout ? 'fixed' : 'auto'">
          <thead>
            <tr>
              <th class="chapter-col" [nzWidth]="columnWidth('chapter')" [attr.aria-sort]="sortMode === 'default' ? 'other' : null">
                <button type="button" class="sort-button sort-button-chapter" (click)="setSort('default')"
                  [class.active]="sortMode === 'default'" [attr.aria-pressed]="sortMode === 'default'"
                  [attr.aria-label]="('sortBy' |translate) + ': ' + ('sortChapterOrder' |translate)">
                  {{'capital' |translate}}
                </button>
              </th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'questions' |translate |titlecase}}</th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'correct' |translate}}</th>
              <th class="stat-col" [nzWidth]="columnWidth('stat')">{{'wrong' |translate}}</th>
              <th class="stat-col stat-unanswered" [nzWidth]="columnWidth('unanswered')">{{'unanswered' |translate}}</th>
              <th class="stat-col stat-percent" [nzWidth]="columnWidth('percent')" [attr.aria-sort]="ariaSortPercent">
                <button type="button" class="sort-button" (click)="toggleWeaknessSort()"
                  [class.active]="sortMode === 'weakness'" [attr.aria-pressed]="sortMode === 'weakness'"
                  [attr.aria-label]="('sortBy' |translate) + ': ' + ('percentCorrect' |translate) + (sortMode === 'weakness' ? ', ' + ('sortedAscending' |translate) : '')">
                  {{'percentCorrect' |translate}}<span class="sort-arrow" aria-hidden="true">{{ sortMode === 'weakness' ? '\u25B2' : '\u21C5' }}</span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of capitalTableList; let i = index" [class.weakest-row]="isWeakest(data)">
              <td class="chapter-col"><b>{{chapterNumber(data)}}.</b> {{data.name}}
                <span class="weakest-badge" *ngIf="isWeakest(data)"><span class="weakest-icon" aria-hidden="true">&#9888;</span> {{'weakestTopic' |translate}}</span>
              </td>
              <td class="stat-col">{{data.total_question}}</td>
              <td class="stat-col">{{data.correct_question_count}}</td>
              <td class="stat-col">{{data.wrong_question_count}}</td>
              <td class="stat-col">{{data.blank_question_count}}</td>
              <td class="stat-col">{{percentCorrect(data)}}</td>
            </tr>
            <tr class="total-row">
                <td class="chapter-col">{{'total' |translate}}</td>
                <td class="stat-col">{{total.total_question}}</td>
                <td class="stat-col">{{total.correct_question_count}}</td>
                <td class="stat-col">{{total.wrong_question_count}}</td>
                <td class="stat-col">{{total.blank_question_count}}</td>
                <td class="stat-col">{{percentCorrect(total)}}</td>
            </tr>
          </tbody>
      </nz-table>
      <div class="button-group">
        <div>
          <button (click)="practiceWrong()" nz-button nzType="primary" nzSize="large" class="first-button">{{'practiceFailed' |translate}}</button>
          <button (click)="practiceBlank()" nz-button nzType="primary" nzSize="large">{{'practiceUnanswered' |translate}}</button>
        </div>
      </div>
      <div class="reset-questions">
        <a (click)="openModel()">{{'resetQuestions' |translate}}</a>
      </div>
    </div>
  </nz-card>
</div>

